import __request__ from "routing/request";
export function pause(nodeId) {
  return __request__("POST", `/cluster/${nodeId}/processing/pause`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function resume(nodeId) {
  return __request__("POST", `/cluster/${nodeId}/processing/resume`, null, {}, {
    "Accept": ["application/json"]
  });
}
